import { render } from "./PrivacyStatementPage.vue?vue&type=template&id=6c7a605f&scoped=true"
import script from "./PrivacyStatementPage.vue?vue&type=script&lang=js"
export * from "./PrivacyStatementPage.vue?vue&type=script&lang=js"

import "./PrivacyStatementPage.vue?vue&type=style&index=0&id=6c7a605f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7a605f"]])

export default __exports__